import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { type } from "@/commons/utils/Rules";
import { getDepartamentos, getTipoViviendas, getFormasDeEnterarse } from "@/routes/api/resources";
import baseform2 from '../baseForm2';
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzDirection from "@/commons/forms/Fields/PzDirection";
export default {
  name: 'PzPersonFormExtPrestama',
  components: {
    PzFormFlujo: PzFormFlujo,
    PzDirection: PzDirection
  },
  mixins: [baseform2],
  data: function data() {
    return {
      properties: [],
      formas_de_enterarse: [],
      provincias: [],
      formulario2: {
        direccion: {},
        provincia: '',
        email: '',
        ref_empresa: '',
        tipo_documento: 1,
        comoseentero: '',
        tipo_vivienda: ''
      },
      disable: true,
      rules_formulario2: {
        email: [type({
          field: '',
          type: 'email'
        })]
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created: function created() {},
  beforeMount: function beforeMount() {
    var _this = this;
    var viv = getTipoViviendas().then(function (res) {
      _this.properties = res.data;
    }).catch(function () {
      _this.properties = [];
    });
    var dep = getDepartamentos().then(function (res) {
      _this.provincias = res.data;
    }).catch(function () {
      _this.provincias = [];
    });
    var form = getFormasDeEnterarse().then(function (res) {
      _this.formas_de_enterarse = res.data;
    }).catch(function () {
      _this.formas_de_enterarse = [];
    });
    Promise.all([viv, dep, form]).then(function () {}).finally(function () {
      _this.$store.dispatch('loader/down', {
        trigger: _this.$options.name
      });
    });
  },
  methods: {}
};